module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-MouseInCanyon-640.3034a3ad.jpg";